/**
 * What was asked (CU-869fmk5ge D3, T7): the copy of the form taken when a search is posted, so the sentence above the
 * results always describes the numbers below (CA 11), plus the names the filters loaded (the sentence's registry).
 * No imports: `node --test` runs it.
 */

// Not part of the question the user edits: the saved-query id, and the specific office (it lives in the copy)
const IGNORED = new Set(['urlId', 'officePickupIDAux'])

const norm = v => {
	if (v === undefined || v === '' || (Array.isArray(v) && !v.length)) return null
	if (Array.isArray(v)) return v.map(x => (x === null || x === undefined ? null : String(x)))
	if (v && typeof v === 'object') return Object.fromEntries(Object.keys(v).sort().map(k => [k, norm(v[k])]))
	return v
}

/** A stable text of a form: sorted keys, ids as text, empty = missing */
export function comparable(form) {
	const f = form || {}
	return JSON.stringify(Object.fromEntries(Object.keys(f).filter(k => !IGNORED.has(k)).sort().map(k => [k, norm(f[k])]).filter(([, v]) => v !== null)))
}

/** The form no longer says what the results answer */
export const isStale = (askedForm, form) => !!askedForm && comparable(askedForm) !== comparable(form)

const copy = v => (v === undefined ? undefined : JSON.parse(JSON.stringify(v)))

/** `{ form, labels, selectedOffice, phase }`, deep-copied */
export function askedFrom({ form, labels = {}, selectedOffice = null, phase = 'searching' }) {
	return { form: copy(form), labels: copy(labels) || {}, selectedOffice: selectedOffice ?? null, phase }
}

/** The registry `{ field: { id: name } }` with the options a filter just loaded */
export function mergeLabels(labels, field, options) {
	const valid = (Array.isArray(options) ? options : []).filter(o => o && o.value !== null && o.value !== undefined && typeof o.label === 'string')
	if (!valid.length) return labels
	return { ...labels, [field]: { ...(labels?.[field] || {}), ...Object.fromEntries(valid.map(o => [String(o.value), o.label])) } }
}
